import TRANSLATION_ACCESSIBILITY_JP from './accessibility/translation';
import TRANSLATIONS_BOOKING_JP from './booking/translation';
import TRANSLATION_EVENTS_JP from './events/translation';
import TRANSLATIONS_EXPERIENCES_JP from './experiences/translation';
import TRANSLATIONS_FORM_JP from './form/translation';
import TRANSLATION_LANDING_PAGES_JP from './landingPages/translation';
import TRANSLATION_RESERVE_JP from './reserve/translation';
import TRANSLATION_SIGNIN_JP from './signin/translation';
import TRANSLATIONS_DATES_JP from './weekdays/translation';

export default {
  ...TRANSLATIONS_DATES_JP,
  ...TRANSLATIONS_BOOKING_JP,
  ...TRANSLATIONS_FORM_JP,
  ...TRANSLATIONS_EXPERIENCES_JP,
  ...TRANSLATION_LANDING_PAGES_JP,
  ...TRANSLATION_EVENTS_JP,
  ...TRANSLATION_RESERVE_JP,
  ...TRANSLATION_ACCESSIBILITY_JP,
  ...TRANSLATION_SIGNIN_JP,
};
